import React from 'react';
const WhyLawrenceOnline = () => {
  const reasons = [
    {
      title: 'Flexible Learning Schedule',
      description: 'Study at your own pace with 24/7 access to course materials and recorded lectures.',
      icon: (
        <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: 'Expert Faculty',
      description: 'Learn from distinguished professors and industry professionals with real-world experience.',
      icon: (
        <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    {
      title: 'Cutting-Edge Curriculum',
      description: 'Access up-to-date courses designed to meet current industry demands and trends.',
      icon: (
        <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      )
    },
    {
      title: 'Interactive Learning',
      description: 'Engage with interactive content, discussion forums, and live Q&A sessions.',
      icon: (
        <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      )
    },
    {
      title: 'Career Support',
      description: 'Benefit from career services, resume building, and job placement assistance.',
      icon: (
        <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      title: 'Affordable Education',
      description: 'Quality education at a fraction of the cost of traditional on-campus programs.',
      icon: (
        <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    }
  ];

  const stats = [
    { label: 'Students Enrolled', value: '50,000+' },
    { label: 'Courses Available', value: '200+' },
    { label: 'Countries Reached', value: '100+' },
    { label: 'Graduation Rate', value: '95%' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-primary py-20 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Why Choose Lawrence Online?</h1>
          <p className="text-xl text-white opacity-90">
            Discover the advantages of learning with our innovative online platform
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Stats */}
          <div className="bg-white rounded-lg shadow-lg p-6 mb-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
              {stats.map((stat, index) => (
                <div key={index} className="p-4">
                  <div className="text-3xl font-bold text-white">{stat.value}</div>
                  <div className="text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Reasons Grid */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
              Top Reasons to Choose Lawrence Online
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {reasons.map((reason, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                    {reason.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{reason.title}</h3>
                  <p className="text-gray-600">{reason.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Student Testimonials */}
          <div className="bg-blue-50 rounded-lg p-8 mb-16">
            <h2 className="text-2xl font-bold text-center text-gray-800 mb-8">What Our Students Say</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                {
                  quote: "Lawrence Online provided me with the flexibility to earn my degree while working full-time. The faculty was incredibly supportive and knowledgeable.",
                  author: "Sarah Johnson",
                  role: "Business Administration Graduate"
                },
                {
                  quote: "The online platform is intuitive and the course materials are top-notch. I felt connected to my professors and classmates throughout the program.",
                  author: "Michael Chen",
                  role: "Computer Science Student"
                }
              ].map((testimonial, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow">
                  <p className="text-gray-600 italic mb-4">"{testimonial.quote}"</p>
                  <div className="font-medium text-gray-800">{testimonial.author}</div>
                  <div className="text-sm text-gray-500">{testimonial.role}</div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Ready to Start Your Journey?</h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Join thousands of students who have transformed their lives through Lawrence Online
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="/apply-now" 
                className="px-8 py-3 bg-primary text-white rounded-md font-medium hover:bg-primary-dark transition-colors"
              >
                Apply Now
              </a>
              <a 
                href="/programs" 
                className="px-8 py-3 border border-white text-white rounded-md font-medium hover:bg-white hover:text-primary transition-colors"
              >
                Explore Programs
              </a>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default WhyLawrenceOnline;
